import { type FC } from 'react'
import { useTranslation } from '@egw/i18n'
import { Chat } from '../../components'

export const FeatureEvergreenIntelligencePage: FC = () => {
  const { t } = useTranslation()
  return (
    <Chat
      instructions={t('default.instructions')}
      isChatOpen
      labels={{ title: t('default.title'), initial: t('default.initial') }}
      isShowBackButton={false}
    />
  )
}
